'use client';
import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { Icon as a } from "@tameeni/icons";
import { cn as n } from "@tameeni/shared-logic";
import { SelectionInputItem as i } from "@tameeni/ui";
function s(e) {
  return /* @__PURE__ */ t(
    i,
    {
      value: e.value,
      className: n(
        "w-full justify-start bg-white border-slate-100 break-words whitespace-normal text-start !text-slate-900",
        e.isSelected ? "bg-blue-100" : "bg-white border-slate-100",
        e.className
      ),
      onClick: () => e.onSelect ? e.onSelect() : void 0,
      children: [
        /* @__PURE__ */ l(a, { className: "flex-shrink-0", name: e.icon }),
        e.label
      ]
    },
    e.value
  );
}
export {
  s as Option
};
//# sourceMappingURL=hero-option.js.map
